import { db } from '../../../../../config/firebase'

export default async function saveBrandOrder(brands) {
  const batch = db.batch()
  brands.forEach((brand, index) => {
    batch.update(db.collection('brands').doc(brand.id), { sortOrder: index })
  })
  await batch.commit()
}
